import React from 'react';
import { Mutation } from "react-apollo"
import { CREATE_BLOG } from "../queries";
import { useHistory } from 'react-router-dom';
import "../blogs.module.css"
import { urlize } from '../../../utils';

const CreateBlogButton = ({location, title, content, email, image}) => {

  const history = useHistory();

    return(
        <Mutation mutation={CREATE_BLOG} onCompleted={(data)=>{history.push(`./blogs/${urlize(title)}`)}}>
            {(createBlog, { loading, error }) => (
              <div className='blogButtonFooter'>
                  <div className='discardBlogButton' onClick={()=>{history.push(`./blogs`)}}>
                    Discard
                  </div>
                  <div className='postBlogButton'
                    onClick={() => {
                      createBlog({ variables: { location: location, title: title, content: content, email: email, image: image } });
                    }}
                  >
                    Post
                  </div>

                </div>
            )}
          </Mutation>
    )
}

export default CreateBlogButton;


// WEBPACK FOOTER //
// ./src/components/Blogs/NewBlog/CreateButton.js